/**
 * Seit 15.10.2026 wohnt die Regel für Kartentext in shared/karten-text.ts — der Server baut daraus die Anzeige
 * (server/werkzeug-anzeige.ts), das Gerät die Karten. Wer sie hier holt, bekommt sie weiter.
 */
export * from "../../shared/karten-text.js";
